import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function select(ctx: Context): any {
    ctx.shared.elements.select = {};

    function init(): void {
        create();
        events();
    }

    // --------------------------------------------------------------------

    function create(): void {
        // Create element (select custom)
        const elSelectCustom = exElement.create({
            merge: ctx.shared.config.select,
            class: {
                new: 'select-custom',
            },
        });
        ctx.shared.elements.element = elSelectCustom;
        ctx.shared.elements.select.element = elSelectCustom;
    }

    function events(): void {
        // Create event (mousedown)
        ctx.shared.elements.element.addEventListener('mousedown', function (this, evt): any {
            //
            if (this.clientWidth >= 170) {
                // Get element (dropdown)
                const elDropdown = ctx.dropdown.getElement();
                // Adjust Dropdown
                elDropdown.style.width = this.clientWidth + 'px';
            }
        });
    }

    // ------------------------------------------------------------------------

    function container(element: HTMLElement): void {
        let dropdownMenu;

        // And when you show it, move it to the body
        /*
         * $(elSelectCustom).on('show.bs.dropdown', function (evt) {
         *      // Get elements (dropdown menu)
         *      const list = evt.target.querySelectorAll('.dropdown-menu');
         *      dropdownMenu = $(list[0]);
         *
         *      // Detach it and append it to the body
         *      $('body').append(dropdownMenu.detach());
         *
         *      // Grab the new offset position
         *      const eOffset = $(evt.target).offset();
         *
         *      // Make sure to place it where it would normally go (this could be improved)
         *      dropdownMenu[0].addStyle({
         *          display: 'block',
         *          top: eOffset.top + $(evt.target).outerHeight() + 'px',
         *          left: eOffset.left + 'px',
         *      });
         *
         *      list[1].addStyle({
         *          display: 'block',
         *      });
         *  });
         *
         *  // And when you hide it, reattach the drop down, and hide it normally
         *  $(elSelectCustom).on('hide.bs.dropdown', function (e) {
         *      $(e.target).append(dropdownMenu.detach());
         *      dropdownMenu.hide();
         *  });
         */
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLElement {
        return ctx.shared.elements.select.element;
    }

    // ------------------------------------------------------------------------

    return {
        init,
        getElement,
    };
}

// ----------------------------------------------------------------------------

export default select;
